import React from "react";
import { useAuth } from "../contexts/AuthContext";
import { Globe, Check } from "@phosphor-icons/react";
import {
  DropdownMenu,
  DropdownMenuTrigger,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
} from "./ui/dropdown-menu";

export const LANGUAGES = [
  { code: "en", name: "English", flag: "EN" },
  { code: "es", name: "Español", flag: "ES" },
  { code: "fr", name: "Français", flag: "FR" },
  { code: "de", name: "Deutsch", flag: "DE" },
  { code: "hi", name: "हिन्दी", flag: "HI" },
  { code: "pt", name: "Português", flag: "PT" },
  { code: "zh", name: "中文", flag: "ZH" },
  { code: "ja", name: "日本語", flag: "JA" },
];

export default function LanguageMenu({ compact }) {
  const { user, updateProfile } = useAuth();
  const current = (user && user !== false ? user.language : "en") || "en";
  const lang = LANGUAGES.find((l) => l.code === current) || LANGUAGES[0];

  const pick = async (code) => {
    if (!user || user === false) return;
    if (code === current) return;
    await updateProfile({ language: code });
  };

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button
          className={`flex items-center gap-1 ${compact ? "px-2 py-1.5 text-xs" : "px-3 py-2 text-sm"} rounded-full bg-sand-100 hover:bg-sand-200 text-ink transition`}
          data-testid="navbar-language"
          aria-label="Change language"
        >
          <Globe size={14} weight="duotone" />
          <span className="font-mono-data">{lang.flag}</span>
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="bg-sand-50 border-sand-200">
        <DropdownMenuLabel className="font-mono-data text-mute text-xs">Diagnosis language</DropdownMenuLabel>
        <DropdownMenuSeparator />
        {LANGUAGES.map((l) => (
          <DropdownMenuItem
            key={l.code}
            onClick={() => pick(l.code)}
            data-testid={`lang-option-${l.code}`}
            className="cursor-pointer focus:bg-sand-100"
          >
            <span className="font-mono-data text-xs w-10 text-mute">{l.flag}</span>
            <span className="flex-1">{l.name}</span>
            {current === l.code && <Check size={14} weight="bold" className="text-forest" />}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
